<template>
    
    <div id="modalId" ref="modal" tabindex="-1" 
        class="fixed top-0 left-0 right-0 z-[200] hidden w-full p-1 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full"
        :style="{ paddingTop: 'max(0.25rem, calc(env(safe-area-inset-top, 0px) + 0.5rem))', paddingBottom: 'max(0.25rem, env(safe-area-inset-bottom, 0px))' }">
        <div class="relative w-full max-w-2xl max-h-full">
            <Transition name="slide-right">
                <!-- Modal content -->
                <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                    <!-- Modal header -->
                    <div class="flex items-center justify-between p-4 md:p-5 rounded-t dark:border-gray-600 border-b">
                        <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                            Create a new Playlist
                        </h3>
                        <button @click="close()" type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>
                            <span class="sr-only">Close modal</span>
                        </button>
                    </div>
                    <!-- Modal body -->
                    <div class="p-4 md:p-5 space-y-4">
                        <FormPlaylist ref="form" @onsaved="onSaved" />
                    </div>
                </div>
            </Transition>
        </div>
    </div>
</template>
<script setup>
import { defineExpose, onMounted, ref, defineEmits } from "vue";
import { Modal } from "flowbite"
import playlistModalStore from "../store/playlist.modal.store"
import sideMenuStore from "../store/sidemenu.store"

const modal = ref(null);
const form = ref(null);
const emit = defineEmits(['saved'])

onMounted( () => {
    let modalElement = new Modal(modal.value, {placement: 'enter', backdrop: 'static'});
    playlistModalStore.state.modal = modalElement

})

const close = () => {
    playlistModalStore.dispatch("close");
}

playlistModalStore.watch( () => playlistModalStore.state.message, () => {
    if (!playlistModalStore.state.error){
        sideMenuStore.dispatch("reloadPlaylists")
        setTimeout( () => {
            close();
        },2000)
    }
})

const onSaved = () => {
    emit('saved');
}

defineExpose({modalPlaylist: modal})



</script>